import { AnyAction } from 'redux';

interface ILocation {
    loading: boolean;
}

const initialState: ILocation = {
    loading: false,
};
export const CreateLocation = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_NEW_LOCATION':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
